import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlaneRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.69 3.66a1.75 1.75 0 0 0-2.5 2.1l3.48 9.74-3.48 9.73a1.74 1.74 0 0 0 2.5 2.11l18.43-10.32a1.75 1.75 0 0 0 .03-3.02l-.03-.02L7.67 3.63l.02.03ZM25.25 15.5l.42-.77-.42.77L6.84 25.83l3.36-9.45h6.37a.87.87 0 0 0 0-1.74H10.2L6.85 5.2l18.39 10.3h.01Z",
		clipRule: "evenodd"
	})
});
export default SvgPaperPlaneRight;
